"use strict";

exports.__esModule = true;
var _DeviceEditor = require("./DeviceEditor");
Object.keys(_DeviceEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceEditor[key]) return;
  exports[key] = _DeviceEditor[key];
});